import { Check, HeartHandshake, Send } from 'lucide-react';

type ConciergeBannerProps = {
  onRequest: () => void;
};

export const ConciergeBanner = ({ onRequest }: ConciergeBannerProps) => (
  <aside className="flex flex-col gap-4 rounded-2xl border border-border-subtle bg-card-base p-6 sm:flex-row sm:items-center sm:justify-between">
    <div className="flex items-start gap-4">
      <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-sage-bg text-sage">
        <HeartHandshake className="h-5 w-5" aria-hidden />
      </span>
      <div>
        <h3 className="font-termina font-medium text-lg text-text-primary">
          Need Help Determining the Right Care Resource?
        </h3>
        <p className="mt-1 text-sm text-text-secondary">
          Connect your client with a Care Concierge consultation.
        </p>
        <ul className="mt-3 grid gap-1.5 text-sm text-text-secondary sm:grid-cols-2">
          {[
            'Expert guidance',
            'Personalized recommendations',
            'Written care guide summary',
            'Advisor informed throughout process',
          ].map((benefit) => (
            <li key={benefit} className="flex items-center gap-2">
              <Check className="h-4 w-4 flex-shrink-0 text-sage" aria-hidden />
              <span>{benefit}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <button
      type="button"
      onClick={onRequest}
      className="inline-flex h-10 flex-shrink-0 items-center gap-2 self-start rounded-full bg-[hsl(40_85%_60%)] px-5 text-sm font-semibold text-[hsl(35_55%_18%)] transition-colors duration-150 ease-out hover:bg-[hsl(40_85%_52%)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-emphasis sm:self-center"
    >
      <Send className="h-4 w-4" aria-hidden />
      Contact Care Concierge
    </button>
  </aside>
);
